export const SocialLinks = {
  Instagram: 'https://www.instagram.com/bouncelife/',
  Tiktok: 'https://www.tiktok.com/@bouncelifeofficial',
  Facebook: 'https://www.facebook.com/bouncedinc',
  Linkedin: 'https://www.linkedin.com/company/bouncedinc'
};
